module.exports = __webpack_public_path__ + "img/login-logo.6ace8ce4.png";